import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const dateTimeFormats = {
    en: {
        month: {
            year: 'numeric',
            month: 'long'
        },
        short: {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        },
        medium: {
            month: 'numeric',
            day: 'numeric',
            weekday: 'long',
            hour: 'numeric',
            minute: 'numeric'
        },
        medium_date: {
            month: 'numeric',
            day: 'numeric',
            year: 'numeric'
        },
        long: {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            weekday: 'long',
            hour: 'numeric',
            minute: 'numeric'
        }
    },
    fr: {
        month: {
            month: 'long',
            year: 'numeric'
        },
        short: {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
        },
        medium: {
            day: 'numeric',
            month: 'numeric',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric'
        },
        medium_date: {
            day: 'numeric',
            month: 'numeric',
            year: 'numeric'
        },
        long: {
            weekday: 'long',
            day: 'numeric',
            month: 'long',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric'
        }
    }
}

const availableLocales = ['fr', 'en']
const defaultLocale = 'en'

import frMessages from "@/i18n/locales/fr.js"
import enMessages from "@/i18n/locales/en.js"

export default new VueI18n({
    silentTranslationWarn: true,
    locale: document.getElementsByTagName('body')[0].dataset.lang || defaultLocale,
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || defaultLocale,
    messages: {
        fr: frMessages,
        en: enMessages

    },
    dateTimeFormats,
});
